<template>
  <div>
    <div class="d-flex justify-content-between">
      <div>
        <div class="section-title">{{ $tc("usersshift", 2) }}</div>
        <div class="section-subTitle my-2">{{ $t("shift_dash_msg") }}</div>
      </div>
      <div class="d-flex">
        <b-button
          v-if="$can('create', 'User Shift')"
          variant="default"
          to="add-users-shifts"
          class="btn-blue"
          >{{ $t("add") }}</b-button
        >
        <b-button variant="default" to="view-users-shifts" class="btn-blue">{{
          $t("view")
        }}</b-button>
      </div>
    </div>

    <div class="d-flex justify-content-between align-items-center my-3">
      <div>
        <b-form-input
          v-debounce:300="onSearch"
          v-model="searchValue"
          placeholder="Search..."
        ></b-form-input>
      </div>
      <div class="d-flex"></div>
      <div class="d-flex align-items-center">
        <div class="d-flex mr-2">
        <multiselect
          :options="extendedCinemaArray"
          v-model="selectedCinema"
          label="cine_name"
          track-by="cine_id"
          placeholder="Cinema"
          :allowEmpty="false"
          :showLabels="false"
          @input="getShiftsList()"
        ></multiselect>
      </div>
        <FilterByStatusDropdown
          :onSelect="
            (filterIsActive) => {
              filter_is_active = filterIsActive;
              columnName = '';
              orderBy = '';
              currentPage = 1;
              getShiftsList(cinema_id);
            }
          "
        />
        <div class="mx-2">
          <b-dropdown name="listview" id="listview" variant="outline-blue">
            <template v-slot:button-content>
              <!-- {{ $t("viewing") }}&nbsp;
              <strong>{{ selectedvalue }}</strong>
              &nbsp;Of&nbsp; -->
              <strong>{{ viewingRange }}</strong>
            </template>
            <b-dropdown-item
              v-for="(list, listIndex) in viewingnumbers"
              :key="listIndex"
              @click="onDropDownChangeValue(list.name)"
              >{{ list.name }}</b-dropdown-item
            >
          </b-dropdown>
        </div>
        <!-- <div class="viewing-status">
          {{ $t('viewing')}}
          <span>1-20</span>of
          <span>36</span>
          <button class="btn-prev mx-2"></button>
          <button class="btn-next"></button>
        </div>-->
        <b-button variant="default" class="btn-blue" @click="onFetch()">{{
          $t("fetch")
        }}</b-button>

        <button
          v-if="GridViewFlag"
          class="btnj btn-gridView mr-3"
          :class="gridView ? 'active' : ''"
          v-on:click="viewType('gridView')"
        ></button>
        <button
          v-if="GridViewFlag"
          class="btnj btn-listView"
          :class="listView ? 'active' : ''"
          v-on:click="viewType('listView')"
        ></button>
      </div>
    </div>

    <!-- GRID VIEW -->
    <div class="desg-grid-container" v-if="gridView">
      <div
        class="col-md-4 col-lg-4 col-xl-3 px-0"
        v-if="UserShifts.length > 0"
        v-for="(item, key) in UserShifts"
        :key="key"
      >
        <div class="desg-box">
          <div class="d-flex justify-content-between">
            <h6>{{ item.first_name }} {{ item.last_name }}</h6>
            <h6>{{ $tc(item.shift_name, 1) }}</h6>
            <div>
              <b-dropdown right variant="edit">
                <b-dropdown-item
                  v-if="$can('update', 'User Shift')"
                  @click="goToRoute('/cinema-manager/edit-users-shifts', item)"
                >
                  <span class="edit-pen mr-1"></span>
                  {{ $t("edit") }}
                </b-dropdown-item>
                <!-- <b-dropdown-item @click="goToRoute('/cinema-manager/view-users-shifts',item)">
                  <span class="icon-eye mr-1"></span>
                  {{ $t('view') }}
                </b-dropdown-item>-->
              </b-dropdown>
            </div>
          </div>

          <div class="d-flex justify-content-between align-items-end">
            <div class="d-flex align-items-end lh-1"></div>
            <div class="d-flex align-items-end">
              <!-- <label class="ios-switch">
                <input
                  :checked="item.us_is_active == 'Y' ? true : false"
                  type="checkbox"
                  class="ios-checkbox"
                  disabled
                />
                <span class="switch-slider"></span>
              </label> -->
              <StatusDot
                :status="
                  item.us_is_active == 'Y'
                    ? 'active'
                    : item.us_is_active == 'N' && 'inactive'
                "
              />
            </div>
          </div>
        </div>
      </div>
      <div v-if="UserShifts.length == 0">
        <p>{{ $t("NoRecords") }}</p>
      </div>
    </div>

    <table class="list-view-table" v-if="listView">
      <thead>
        <tr>
          <th class="text-left" style="width: 100px">
            <span class="pr-5">{{ $tc("status", 2) }}</span>
          </th>
          <th style="width: 200px">
            <img
              v-if="this.columnName != 'first_name'"
              @click="onSortValue('first_name', 'asc')"
              src="@/assets/img/icons/updown.svg"
              class="cursor-pointer"
              width="15px"
              height="20px"
            />
            <img
              v-else-if="isSort && isAscending"
              @click="onSortValue('first_name', 'asc')"
              src="@/assets/img/icons/asc.svg"
              class="cursor-pointer"
              width="15px"
              height="20px"
            />
            <img
              v-else
              @click="onSortValue('first_name', 'desc')"
              src="@/assets/img/icons/desc.svg"
              class="cursor-pointer"
              width="15px"
              height="20px"
            />
            {{ $tc("username", 1) }}
          </th>
          <th style="width: 200px">
            <img
              v-if="this.columnName != 'shift_name'"
              @click="onSortValue('shift_name', 'asc')"
              src="@/assets/img/icons/updown.svg"
              class="cursor-pointer"
              width="15px"
              height="20px"
            />
            <img
              v-else-if="isSort && isAscending"
              @click="onSortValue('shift_name', 'asc')"
              src="@/assets/img/icons/asc.svg"
              class="cursor-pointer"
              width="15px"
              height="20px"
            />
            <img
              v-else
              @click="onSortValue('shift_name', 'desc')"
              src="@/assets/img/icons/desc.svg"
              class="cursor-pointer"
              width="15px"
              height="20px"
            />
            {{ $tc("shift", 1) }}
          </th>
          <th>{{ $tc("cinema", 1) }}</th>
          <th style="width: 200px">
            <img
              v-if="this.columnName != 'us_start_date'"
              @click="onSortValue('us_start_date', 'asc')"
              src="@/assets/img/icons/updown.svg"
              class="cursor-pointer"
              width="15px"
              height="20px"
            />
            <img
              v-else-if="isSort && isAscending"
              @click="onSortValue('us_start_date', 'asc')"
              src="@/assets/img/icons/asc.svg"
              class="cursor-pointer"
              width="15px"
              height="20px"
            />
            <img
              v-else
              @click="onSortValue('us_start_date', 'desc')"
              src="@/assets/img/icons/desc.svg"
              class="cursor-pointer"
              width="15px"
              height="20px"
            />
            {{ $tc("shiftstartdate", 1) }}
          </th>
          <th>
            <img
              v-if="this.columnName != 'us_end_date'"
              @click="onSortValue('us_end_date', 'asc')"
              src="@/assets/img/icons/updown.svg"
              class="cursor-pointer"
              width="15px"
              height="20px"
            />
            <img
              v-else-if="isSort && isAscending"
              @click="onSortValue('us_end_date', 'asc')"
              src="@/assets/img/icons/asc.svg"
              class="cursor-pointer"
              width="15px"
              height="20px"
            />
            <img
              v-else
              @click="onSortValue('us_end_date', 'desc')"
              src="@/assets/img/icons/desc.svg"
              class="cursor-pointer"
              width="15px"
              height="20px"
            />
            {{ $tc("shiftenddate", 1) }}
          </th>
        </tr>
      </thead>
      <tbody v-if="UserShifts.length > 0">
        <tr v-for="(item, key) in UserShifts" :key="key">
          <td>
            <div class="d-flex align-items-center justify-content-start">
              <StatusDot
                :status="item.us_is_active == 'Y' ? 'active' : 'inactive'"
              />
              <div
                v-if="$can('update', 'User Shift')"
                class="edit-icon ml-4 blue-icon"
                @click="goToRoute('/cinema-manager/edit-users-shifts', item)"
                style="cursor: pointer"
                v-b-tooltip="'Edit'"
                tabindex="0"
              >
                <i class="edit-pen icon blue-icon"></i>
              </div>
            </div>
          </td>

          <td>{{ item.first_name }} {{ item.last_name }}</td>
          <td>{{ $tc(item.shift_name, 1) }}</td>
          <td>{{ item.cine_name }}</td>
          <td>{{ item.us_start_date | dateparse }}</td>
          <td>{{ item.us_end_date | dateparse }}</td>
        </tr>
      </tbody>
      <!-- <div v-if="UserShifts.length == 0">
        <p>{{ $t('NoRecords') }}</p>
      </div>-->
      <tbody v-if="UserShifts.length == 0">
        <tr>
          <td colspan="5">
            <!-- <div class="h6 my-3 text-center">{{ $t("NoRecords") }}</div> -->
            <NoRecords />
          </td>
        </tr>
      </tbody>
    </table>
    <b-pagination
      v-model="currentPage"
      :total-rows="rows"
      @change="onChangePagination($event)"
      :per-page="perPage"
      aria-controls="my-table"
    ></b-pagination>
  </div>
</template>

<script>
import MasterService from "@/services/MasterService";
import Shifts from "@/helper/formJSONMaster/Shifts";
import StatusDot from "@/components/Partials/StatusDot.vue";
import FilterByStatusDropdown from "@/components/Partials/FilterByStatusDropdown.vue";
import NoRecords from "@/components/Partials/NoRecords.vue";

export default {
  components: {
    StatusDot,
    FilterByStatusDropdown,
    NoRecords,
  },
  data() {
    return {
      perPage: 10,
      currentPage: 1,
      rows: 0,
      selectedvalue: "10",

      debounce: null,
      searchValue: "",

      gridView: false,
      listView: true,
      Methods: Shifts.Methods,
      UserShifts: [],
      viewingnumbers: [],
      customErrors: {
        message: "",
      },
      loading: true,
      cinema_id: null,
      //Sorting data
      isSort: false,
      isAscending: true,
      orderby: "",
      columnName: "",
      filter_is_active : "Y",
      selectedCinema: null,
      Cinemas: [],
      CinemasMethods: {
        GET: "/admin/",
        tableName: "ms_cinemas",
        urlKey: "cinemas",
      },
    };
  },
  beforeMount() {
    let obj = this.secureStore.get("USINFO").cinema_id;
    this.cinema_id = obj;
    // this.getShiftsList(obj);
    this.getviewingnumber();
    this.getCinemasList();
  },
  computed: {
    viewingRange() {
      if (this.rows === 0) {
        return "Viewing 0 to 0 of 0";
      }

      const start = (this.currentPage - 1) * this.perPage + 1;
      const end = Math.min(this.currentPage * this.perPage, this.rows);

      return `Viewing ${start} to ${end} of ${this.rows}`;
    },

    extendedCinemaArray() {
      let activeCinemas = this.Cinemas.filter(
        (cinema) => cinema.cine_is_active == true
      );
      return [{ cine_name: "All", cine_id: null }, ...activeCinemas];
    },
  },

  methods: {
    getCinemasList: function (cine_id) {
      this.Cinemas = [];
      // console.log("cine_id :", cine_id);
      let body = this.getRequestBody("GET", undefined, this.CinemasMethods);
      MasterService.GlobalRequest(body)
        // MasterService.GetActiveList(payload)
        .then((response) => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.Cinemas = data.Records;
            console.log('this.Cinemas:', this.Cinemas)
            this.UserShifts = this.UserShifts.map((user) => {
              this.Cinemas.map((cinema) => {
                if (String(user.cinema_id) === String(cinema.cine_id)) {
                  user["cinemaname"] = cinema.cine_name;
                }
              });
              return user;
            });
          } else {
            // Show Errors
            console.log("show error :", data.message);
          }
        })
        .catch(this._CatchError);
    },
    onSearch: function () {
      this.getShiftsList(this.cinema_id);
    },
    onFetch: function () {
      this.getShiftsList(this.cinema_id);
    },

    onCinemaSelectChange(event) {
      this.selectedCinema = this.Cinemas.find(
        (c) => c.cine_id === parseInt(event.target.value)
      );
      this.currentPage = 1;
      this.getShiftsList(this.selectedCinema);
    },

    getviewingnumber() {
      this.viewingnumbers = [
        { name: "All", id: 1 },
        { name: "10", id: 2 },
        { name: "20", id: 3 },
        { name: "30", id: 3 },
        { name: "40", id: 4 },
        { name: "50", id: 5 },
      ];
    },
    onDropDownChangeValue(event) {
      if (event == "All") {
        this.perPage = this.rows;
        this.selectedvalue = event;
        this.onChangePagination();
      } else {
        // console.log("Numbers :", event);
        this.selectedvalue = event;
        this.perPage = event;
        // console.log("perPage :", this.perPage);
        this.onChangePagination();
      }
    },

    /* eslint-disable */
    onChangePagination: function (event) {
      // console.log(event);
      if (event === undefined) {
        this.currentPage = 1;
        this.getShiftsList(this.cinema_id);
      } else {
        this.currentPage = event;
        this.getShiftsList(this.cinema_id);
      }
    },
    goToRoute: function (path, item) {
      // console.log("item :", item);
      const { us_id } = item;
      this.$router.push({
        path: path,
        query: {
          us_id: us_id,
        },
      });
    },
    //Sort
    onSortValue(columnName, orderby) {
      this.isSort = true;
      this.isAscending = !this.isAscending;
      this.columnName = columnName;
      this.orderby = orderby;
      this.getShiftsList();
    },
    getShiftsList: function (cinema_id) {
      this.UserShifts = [];
      const selectedCinemaId = (this.selectedCinema && this.selectedCinema.cine_id) || null;
      let payload = {
        tableName: "user_shifts",
        limit: this.perPage,
        currentPage: this.currentPage,
        cinema_id: cinema_id,
        columnName: this.columnName,
        orderBy: this.orderby,
        searchValue: this.searchValue,
        filter_is_active: this.filter_is_active,
        cine_id: selectedCinemaId,
      };
      MasterService.GetAllUserShifts(payload)
        .then((response) => {
          const { data } = response;
          if (data.status) {
            if (data.Records.length > 0) {
              this.UserShifts = data.Records;
              // this.getCinemasList();
              if (data.totalRows >= 10) {
                this.rows = data.totalRows;
              } else {
                this.rows = data.totalRows;
                this.selectedvalue = data.totalRows;
              }
              if (this.loading) {
                // this.UserShifts.reverse();
                this.loading = false;
              }
            } else {
              this.customErrors.message = data.message;
            }
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError);
    },

    viewType: function (viewType) {
      if (viewType == "gridView") {
        this.gridView = true;
        this.listView = false;
      } else if ((viewType = "listView")) {
        this.listView = true;
        this.gridView = false;
      }
    },
  },

  watch: {
    selectedCinema: function (newVal, oldVal) {
      this.currentPage = 1;
      this.getShiftsList();
    }
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Pages/ExhibitorManagement/UsershiftsComponents/userShifts.vue